import React from "react";

const tons = (value) => `${Number(value).toLocaleString("fr-CA", { maximumFractionDigits: 3 })} t`;
const summary = (items) => `${items.length} compartiment${items.length === 1 ? "" : "s"} · ${tons(
  items.reduce((total, item) => total + Number(item.capacity_tons), 0),
)}`;

export default function TruckCompartmentChanges({ before, after }) {
  const previous = Array.isArray(before) ? before : [];
  const current = Array.isArray(after) ? after : [];
  const oldByPosition = new Map(previous.map((item) => [item.position, item]));
  const newByPosition = new Map(current.map((item) => [item.position, item]));
  const positions = [...new Set([...oldByPosition.keys(), ...newByPosition.keys()])].sort((a, b) => a - b);
  const changes = positions.flatMap((position) => {
    const old = oldByPosition.get(position);
    const next = newByPosition.get(position);
    if (!next) return [`N° ${position} supprimé (${tons(old.capacity_tons)})`];
    if (!old) return [`N° ${position} ajouté (${tons(next.capacity_tons)})`];
    if (old.capacity_tons !== next.capacity_tons) return [`N° ${position} : ${tons(old.capacity_tons)} → ${tons(next.capacity_tons)}`];
    if (old.compartment_id !== next.compartment_id) return [`N° ${position} remplacé (${tons(next.capacity_tons)})`];
    return [];
  });
  return (
    <span className="grid gap-0.5" data-truck-compartment-changes>
      <span>{summary(previous)} → {summary(current)}</span>
      {changes.map((change) => <span key={change}>{change}</span>)}
    </span>
  );
}
